var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lg:py-8 lg:px-12 h-screen flex flex-row justify-center items-center"},[_c('logo',{attrs:{"height":"8rem"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }